$(document).ready(function () {
	
	
	$('#kita-search .nav-tabs a').on('click', function(e){
		
		e.preventDefault();
		
		$('#kita-search .tabform').hide();
		$('#kita-search .nav-tabs li').removeClass('active');
		
		$(this).parent().addClass('active');
		$( $(this).attr('href') ).show();
			
	});
	
	
	$(".map_button").on('click',function(){
		
		mapElement.trigger('focus-poi.map', $(e.target).parents('[data-poi]'));
		
		$("html, body").animate({
	    	scrollTop: mapElement.offset().top + SCROLL_OFFSET
	  	});

	})


});